<template>
    <SideBar>
        <div
            class="section-notifications"
            :class="{ 'no-padding': step === 2 }"
        >
            <template v-if="step === 1">
                <h1 class="section-notifications__title t-transform-cap">
                    {{ getTranslatedText("notifications") }}
                    <img
                        src="@/assets/images/common/vector-down.png"
                        @click="onShowBottomMenuList"
                    />
                </h1>
                <ul class="section-notifications__list-notifications">
                    <li
                        v-for="(item, index) in listNotifications"
                        :key="index"
                        class="section-notifications__item-notifications"
                        :class="{ 'high-lights': !item.notified }"
                        @click="handleReadNotify(item.id, index)"
                    >
                        <div
                            class="section-notifications__item-notifications-title"
                        >
                            <h1>
                                {{ getTranslatedText(item.title) }}
                            </h1>
                            <span>{{ renderDateNotication(item.date) }}</span>
                        </div>
                        <p
                            class="section-notifications__item-notifications-description"
                        >
                            {{ item.description }}
                        </p>
                    </li>
                </ul>
            </template>
            <template v-if="step === 2"
                ><NotificationDetail
                    :dataDetail="dataDetail"
                    @onGoBack="onGoBack"
            /></template>

            <vue-bottom-sheet max-height="90%" ref="bottomMenuList">
                <BottomSheet :isHiddenBtn="true">
                    <template slot="body-sheet">
                        <ul class="bottom-sheet-list-navigation__menu-list">
                            <li
                                v-for="(item, index) in listMenuNavigation"
                                :key="index"
                                v-show="item.isShow"
                                class="bottom-sheet-list-navigation__menu-item"
                            >
                                <div
                                    @click="handleClickRedirect(item)"
                                    class="bottom-sheet-list-navigation__menu-item-content t-transform-cap"
                                >
                                    <img
                                        class="user-avatar"
                                        :src="
                                            require(`@/assets/images/navigation/${item.icon}`)
                                        "
                                        :alt="item.icon"
                                    />
                                    {{ getTranslatedText(item.title) }}
                                </div>
                            </li>
                        </ul>
                    </template>
                </BottomSheet>
            </vue-bottom-sheet>
        </div>
    </SideBar>
</template>
<script>
import { listMenuNavigation } from "@/resources/listNavigation";
import {
    isArrayEmpty,
    isStrEmpty,
    redirectPathApp,
    removeTagHtml,
} from "@/components/common/utils";

import notificationsService from "@/services/notification.service";
import BottomSheet from "@/components/common/bottom-sheet";
import NotificationDetail from "@/views/mobile/notifications/detaii";
import SideBar from "@/components/common/sidebar/SideBar";
import moment from "moment";

import languageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin"

export default {
    mixins: [languageMixin, RouterMixin],
    components: {
        BottomSheet,
        NotificationDetail,
        SideBar,
    },
    data() {
        return {
            step: 1,
            dataDetail: null,
            indexEdit: -1,
            listMenuNavigation,
            listNotifications: [],
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        handleReadNotify(id, index) {
            notificationsService.readNotify(id).then((res) => {
                if (res.status === 200) {
                    this.$store.dispatch("setUnreadNotify");
                    this.fetchData();
                }
            });
            this.onClickShowDetail(index);
        },
        async fetchData() {
            try {
                const locale = localStorage.getItem("locale");
                const resp = await notificationsService.getList(locale);
                if (!isArrayEmpty(resp.data)) {
                    let isTagHtml = /<[^>]*>?/gm;
                    let listFavourite = resp.data.map((item) => {
                        let description = !isStrEmpty(item.description)
                            ? isTagHtml.test(item.description)
                                ? removeTagHtml(
                                      this.getTranslatedText(item.description)
                                  ).replace(/^(.{100}[^\s]*).*/, "$1")
                                : item.description
                            : "";

                        return {
                            id: item.id,
                            title: !isStrEmpty(item.title)
                                ? item.title.replace(/^(.{20}[^\s]*).*/, "$1")
                                : item.message.replace(
                                      /^(.{20}[^\s]*).*/,
                                      "$1"
                                  ),
                            description,
                            html: item.content,
                            date: item.updated_at,
                            notified: item.notified,
                        };
                    });

                    this.listNotifications = listFavourite;
                }
            } catch (error) {
                console.log(error);
            }
        },
        onShowBottomMenuList() {
            this.$refs.bottomMenuList.open();
        },

        onGoBack() {
            this.step = 1;
            this.dataDetail = null;
        },

        onClickShowDetail(index) {
            this.dataDetail = { ...this.listNotifications[index] };
            this.step = 2;
        },

        renderDateNotication(date) {
            let locale = this.$store.state.isRtl ? "ar" : "en";
            moment.locale(locale);
            const timestamp = moment(date).fromNow(true);
            return timestamp;
        },

        handleClickRedirect(item) {
            if (this.$store.state.is_app && item.isRedirect) {
                redirectPathApp(item.url);
            } else {
                this.routerPush(item.url);
            }
        },
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/notification/_notification.scss"
/>
